// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SoloPostBlockSlice_wrapper__CPbPo"};